<main>
  <div #statusBarWrapper>
    @if (noMessages()) {
      <bi-notification-bar
        class="mb-0"
        widthSize="large"
        [title]="'iframe.operationalMap.NoMessages' | translate"
        [dismissable]="false"
        [cssFontColor]="urlParams.noMessagesFontColor"
        backgroundColor="green"
        [cssBackgroundColor]="urlParams.noMessagesBackgroundColor"
        [font]="urlParams.noMessagesFont"
      />
    }
  </div>

  @if (mapModuleModel && urlParams?.height && noMessages() != undefined) {
    <bi-map
      class="iframe-component"
      #map
      [enableSearch]="mapModuleModel.customerSettings.hasSearchInput"
      [countryId]="mapModuleModel.countryId"
      [noPosListSearch]="true"
      [enableDraw]="false"
      [mapHeight]="urlParams.height"
      [enableMarkerClusters]="false"
      [markersDeletable]="false"
      [isForDriftStatus]="true"
      [reloadButtonClick]="setupMapLatLngAndZoom"
      [defaultMapLayerId]="mapModuleModel.customerSettings.mapLayerId"
      (mapReady)="onMapReady($event)"
    />
  } @else if (loading || (!mapModuleModel && !urlParams?.height && noMessages() == undefined)) {
    <bi-spinner spinnerSize="large" [hasBackground]="loading" [centerInParent]="true" />
  }
</main>
